"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcessibilidadeContraste = void 0;
var react_1 = require("react");
var useAcessibilidadeContraste = function () {
    var _a = (0, react_1.useState)('white'), contrasteEstado = _a[0], setContrasteEstado = _a[1];
    var definirContraste = (0, react_1.useCallback)(function () {
        if (contrasteEstado === 'white') {
            setContrasteEstado('black');
        }
        else {
            setContrasteEstado('white');
        }
    }, [contrasteEstado]);
    return {
        definirContraste: definirContraste,
        contrasteEstado: contrasteEstado,
    };
};
exports.useAcessibilidadeContraste = useAcessibilidadeContraste;
